





export default
  name: 'LoadingCursor'

  props: ['loading']

  data: ->
    timer: false

  mounted: ->
    follower = document.querySelector '.cursor-loading'
    window.onmousemove = (event) =>
      @timer = setTimeout =>
        follower.style.top = event.clientY + 'px'
        follower.style.left = event.clientX + 'px'
      , 1

